import React, { useEffect, useState } from "react";
import { Breaker, Button, Flexbox, InputField } from "../../Theme/GlobalStyles";
import { Text } from "../../Theme/Typography";
import { CloseCircle } from "../../Theme/Icons";
import { globalTheme } from "../../Theme/Theme";
import { PopupBody, PopupWrapper } from "./CommonPopup";
import {
  clearCoworkSliceStates,
  coworkData,
  getAllTowers,
  postTower,
} from "../../../redux/cowork/coworkSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

// Restores the old "Add Tower" flow (AllRooms → AddTowerPopup) in the new UI.
// Uses the shared /add-towerAndAmenities endpoint (postTower) and refreshes the
// tower list on success so the new tower appears in the room form dropdowns.
const AddTowerPopup = ({ isActive, togglePopup }) => {
  const [towerName, setTowerName] = useState("");
  const dispatch = useDispatch();
  const {
    isCoworkSliceFetching,
    isCoworkSliceSuccess,
    isCoworkSliceError,
    coworkSliceErrorMessage,
  } = useSelector(coworkData);

  useEffect(() => {
    if (!isActive) return;
    setTowerName("");
  }, [isActive]);

  useEffect(() => {
    if (isActive && isCoworkSliceSuccess) {
      dispatch(getAllTowers());
      dispatch(clearCoworkSliceStates());
      togglePopup(false);
    }
  }, [isCoworkSliceSuccess]);

  useEffect(() => {
    if (isCoworkSliceError) {
      toast.error(coworkSliceErrorMessage, {
        autoClose: 3000,
      });
      dispatch(clearCoworkSliceStates());
    }
  }, [isCoworkSliceError, coworkSliceErrorMessage]);

  const addTower = () => {
    if (!towerName?.trim()) {
      toast.error("Please enter a tower name", {
        autoClose: 3000,
      });
      return;
    }
    dispatch(postTower({ towerName: towerName.trim() }));
  };

  return (
    <PopupWrapper className={`${isActive ? "active" : ""}`}>
      <PopupBody maxWidth={480} padding={24}>
        <Flexbox spaceBW alignCenter>
          <Text font18 inter semiBold white maxWidth="max-content">
            Add New Tower
          </Text>
          <CloseCircle className={"pointer"} onClick={() => togglePopup(false)} />
        </Flexbox>
        <Breaker marginTop={16} marginBottom={20} borderColor={globalTheme.colors.white1} />
        <Flexbox flexEnd>
          <InputField
            label="Tower Name"
            isImp
            placeholder="Enter Tower Name"
            onChange={(e) => setTowerName(e.target.value)}
            value={towerName}
          />
        </Flexbox>
        <Flexbox alignCenter gap={12} justiCenter className="mt20">
          <Button
            whiteFilled
            buttonMd
            name={"Cancel"}
            disabled={isCoworkSliceFetching}
            onClick={() => togglePopup(false)}
          />
          <Button
            primaryFilled
            buttonMd
            name={"Add Tower"}
            onClick={addTower}
            disabled={isCoworkSliceFetching}
            isLoading={isCoworkSliceFetching}
          />
        </Flexbox>
      </PopupBody>
    </PopupWrapper>
  );
};

export default AddTowerPopup;
